import { trimQuotes } from '@reward-platform/shared-schemas'

export const sanitizeCurrencyCode = (currencyCode: string | undefined | null): string => {
  if (!currencyCode) {
    return 'GBP'
  }
  return trimQuotes(String(currencyCode).trim()) || 'GBP'
}

export const createCurrencyFormatter = (
  currencyCode = 'GBP',
  locale = 'en-GB',
  options: Intl.NumberFormatOptions = {}
) => {
  const sanitizedCurrency = sanitizeCurrencyCode(currencyCode)
  return new Intl.NumberFormat(locale, {
    ...(sanitizedCurrency ? { style: 'currency', currency: sanitizedCurrency } : {}),
    minimumFractionDigits: 0,
    ...options,
  })
}
